<template>
  <div v-if="brinde" class="card card-body shadow-sm mt-0">
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">Detalhes do Brinde</h4>
      <router-link to="/cadastros/brindes">
        <button class="btn btn-secondary btn-sm">Voltar</button>
      </router-link>
    </div>

    <div class="form-content mt-3">
      <!-- Seção de Informações Básicas -->
      <FormSection title="">
        <p><strong>Nome:</strong> {{ brinde.nome || 'Não informado' }}</p>
        <p><strong>Ativo:</strong> {{ verificarAtivo(brinde?.ativo) }}</p>
      </FormSection>

      <!-- Seção de Descrição -->
      <FormSection title="">
        <p><strong>Descrição:</strong> {{ brinde.descricao || 'Não informado' }}</p>
      </FormSection>
    </div>
  </div>

  <div v-else>
    <LoadingSpinner />
  </div>
</template>

<script>
import axios from "@/services/axios";
import FormSection from "@/components/Layout/FormSection.vue";

export default {
  components: { FormSection },
  data() {
    return {
      brinde: null,
    };
  },
  methods: {
    async carregarDetalhesBrinde() {
      try {
        const response = await axios.get(
          `/cadastros/brindes/${this.$route.params.id}`
        );
        // Removida a atribuição de categoria, pois não é mais utilizada.
        this.brinde = response.data;
      } catch (error) {
        console.error("Erro ao carregar os detalhes do brinde:", error);
      }
    },
    verificarAtivo(valor) {
      if (valor === undefined || valor === null) {
        return "Não informado";
      }
      return valor ? "Ativo" : "Inativo";
    },
  },
  mounted() {
    this.carregarDetalhesBrinde();
  },
};
</script>

<style scoped>
.card {
  max-width: 800px; /* Ajustado para centralizar melhor */
  margin: 0 auto;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0rem;
}

.form-header h4 {
  margin: 0;
  font-weight: bold;
  text-align: left;
}

.form-content {
  margin-top: 1.5rem;
}

button.btn-sm {
  padding: 6px 12px;
}
</style>
